import { Group } from "@mantine/core"
import { useSuspenseQueryGet } from "../typed-client/hooks/use-suspense-query-get"
import { useEnvironment } from "./useEnvironment"

export function HideOnProd(props: React.PropsWithChildren) {
  if (import.meta.env.DEV) {
    return props.children
  }
}

type EnvironmentName = "production" | "development" | "qa" | (string & object)

export function HideOnEnvironment(
  props: React.PropsWithChildren<{
    env: EnvironmentName
  }>
) {
  const data = useEnvironment()
  if (data.name.toLowerCase() === props.env) {
    return null
  }
  return props.children
}

export function ShowOnEnvironment(
  props: React.PropsWithChildren<{
    env: EnvironmentName
    orIfDebugControlsEnabled: boolean
  }>
) {
  const { data } = useSuspenseQueryGet("/api/Environment", null)
  if (data.name.toLowerCase() === props.env) {
    return props.children
  }
  return null
}

export function ShowIfDebugControlsEnabled(
  props: React.PropsWithChildren<object>
) {
  const data = useEnvironment()
  if (data.showDebugControls) {
    return <Group>{props.children}</Group>
  }
  return null
}
